<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Betty Roberts was born in Wyoming County, West Virginia, graduated high school at Matoaka High, followed by graduation from the University of Virginia School of Nursing in Charlottesville, Virginia. Betty had an active career as a nurse, working in the delivery room or as a General Supervisor, with the last eight years of her nursing career spent in long term care. Betty also attended the University of Alabama in Huntsville and in Tuscaloosa, concentrating on her first love, writing. After retiring, Betty studied oil painting and with seven children and numerous grands and greats, she has no problem getting rid of her paintings. Betty spends her time writing, painting and enjoying her large family. Her other works: <em>Leaning into the Wind: The Wilderness of Widowhood</em> (under the name of Betty Bryant), <em>Midnight Chronicles: A Love Story</em> by Betty Roberts, <em>Cave-In</em> a short story published in the Scribbler, University of Alabama in Huntsville Magazine (under the name of Betty Osborne) and her latest book <em>Still Climbing</em> published under the name Betty Roberts.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3dbd9e62